import SavingsFollowupReportActionTypes from './savings-followup.types';

/** ***************** GET SAVINGS FOLLOWUP REPORT START *********************** */
export const getSavingsFollowupReportStart = (getData: any) => ({
	type: SavingsFollowupReportActionTypes.GET_SAVINGS_FOLLOWUP_REPORT_START,
	payload: getData,
});

export const getSavingsFollowupReportSuccess = (successData: any) => ({
	type: SavingsFollowupReportActionTypes.GET_SAVINGS_FOLLOWUP_REPORT_SUCCESS,
	payload: successData,
});

export const getSavingsFollowupReportFailure = (failureData: any) => ({
	type: SavingsFollowupReportActionTypes.GET_SAVINGS_FOLLOWUP_REPORT_FAILURE,
	payload: failureData,
});

export const getSavingsFollowupReportResponseResetStart = () => ({
	type: SavingsFollowupReportActionTypes.GET_SAVINGS_FOLLOWUP_REPORT_RESPONSE_RESET,
});

export const getSavingsFollowupReportResponseChanged = () => ({
	type: SavingsFollowupReportActionTypes.GET_SAVINGS_FOLLOWUP_REPORT_RESPONSE_CHANGED,
});
/** ***************** GET SAVINGS FOLLOWUP REPORT END *********************** */
